import React from 'react'

const Follow = () => {
    return (
        <div className="w-24 md:w-40 rounded-2xl md:rounded-3xl h-10 flex gap-1 justify-center items-center border border-logoRed">
            <button className='font-bold text-sm text-logoRed'>Follow</button>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="text-logoRed bi bi-plus" viewBox="0 0 16 16">
                <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
            </svg>
        </div>
    )
}

export default Follow